import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';
import {
  Employee,
  EmployeeDetails,
  InviteEmployeeRequest,
  InviteEmployeeResponse,
  UpdateEmployeeRequest,
} from './type';

export const employeesApi = createApi({
  reducerPath: 'employeesApi',
  tagTypes: ['Employees', 'Employee'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 10,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    inviteEmployee: build.mutation<InviteEmployeeResponse, InviteEmployeeRequest>({
      query: (body) => ({
        url: '/customer/employees',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Employees'],
    }),

    getEmployeesList: build.query<Employee[], void>({
      query: () => ({
        url: '/customer/employees',
        method: 'GET',
      }),
      providesTags: ['Employees'],
    }),

    updateEmployee: build.mutation<void, { employeeId: number } & UpdateEmployeeRequest>({
      query: ({ employeeId, ...body }) => ({
        url: `/customer/employees/${employeeId}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Employees', 'Employee'],
    }),

    deleteEmployee: build.mutation<void, { employeeId: number }>({
      query: ({ employeeId }) => ({
        url: `/customer/employees/${employeeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Employees'],
    }),

    getEmployeeDetails: build.query<EmployeeDetails, { employeeId: number }>({
      query: ({ employeeId }) => ({
        url: `/customer/employees/${employeeId}`,
        method: 'GET',
      }),
      providesTags: ['Employee'],
    }),
  }),
});

export const {
  useInviteEmployeeMutation,
  useGetEmployeesListQuery,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation,
  useGetEmployeeDetailsQuery,
} = employeesApi;
